module.exports = __webpack_public_path__ + "static/img/hk.269760a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/hk.png
// module id = cShr
// module chunks = 0